<template>
  <div class="tr-test game-tr-multi-checkbox-impr" :style="'text-align: left;font-size:' + gameFontSize">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div
      class="element-container"
      :class="[{ block: inputStatus(elementIndex) === 'correct' }]"
      v-for="(element, elementIndex) in dataItems"
      :key="'element_' + elementIndex"
      :id="'element_' + elementIndex"
      @click="resetCheckStatus"
      :style="getElementStyle(element)"
    >
      <div class="item-container inner-element-container">
        <div class="">
          <label class="checkbox-container" :class="[{ block: selected['element_' + elementIndex].block }]">
            <div class="text-container">{{ element.text }}</div>
            <tr-check-box
              :checkbox-data-model="selected['element_' + elementIndex]"
              :main-index="elementIndex"
              :index="elementIndex"
            ></tr-check-box>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtilsV2';
import defaultMixin from '../../mixins/defaultMixinV2';
import selectGameMixin from '../../mixins/selectGameMixinV2';
import TrCheckBox from './TrCheckBox/TrCheckBoxV2';
export default {
  name: 'tr-multi-checkbox-impr-v2',
  components: { TrCheckBox },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin, selectGameMixin],
  data() {
    return {
      dataItems: {},
      textList: {},
      selected: [],
      imageData: {},
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.checkboxGamePrepareData();
      let selectedItem = _.sample(this.dataItems);
      if (selectedItem.imageData) {
        this.imageData = selectedItem.imageData;
      } else if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      }
      _.each(this.dataItems, (item, elemIndex) => {
        this.selected = _.assign({}, this.selected, {
          ['element_' + elemIndex]: { correct: item.correct || false, value: false, block: false, status: 'rest' },
        });
      });
      // console.log('this.selected', this.selected);
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      };
    },
    inputStatus(index) {
      let element = 'element_' + index;
      let status = 'unset';
      if (this.$store.getters.gameCheckSwitch && this.selected[element] === 'CORRECT') {
        status = 'correct';
      } else if (this.$store.getters.gameCheckSwitch) {
        status = 'incorrect';
      }
      if (
        document.querySelector(['#element_', index].join('')) &&
        document.querySelector(['#element_', index].join('')).classList.contains('block')
      ) {
        status = 'correct';
      }
      return status;
    },
    isText(obj) {
      return _.has(obj, 'text');
    },
    isImageInQuestionInQuestion(obj) {
      return _.some(obj.answers, 'imagePath');
    },
    selectRadioButto(qIndex, aIndex) {
      let element = this.$refs['question' + qIndex + 'answer' + aIndex];
      this.selected['element_' + qIndex] = element[0].value;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      // /** @type {Boolean} set gameCheckSwitch to false - remove statys icons */
      // _.each( _.cloneDeep( this.questionsList ), ( question, questionIndex ) => {
      //   _.each( question.answers, ( answer, answerIndex ) => {
      //     this.selected = _.assign( {}, this.selected, {
      //     [ 'element_' + questionIndex + '_' + answerIndex ]: { correct: answer.correct || false, value: false, block: false, status: 'rest' }
      //     } );
      //   } );
      // } );
      // this.questionsList = this.processQuestionsList();
      this.init();
    },
    checkGameAction() {
      // console.log('this.selected', this.selected);
      let status = _.reduce(
        this.selected,
        (result, item, key) => {
          let temVal = null;
          if ((item.correct === true && item.value === true) || (item.correct === false && item.value === false)) {
            temVal = result && true;
            item.status = 'correct';
            item.block = item.value === true ? true : false;
          } else {
            temVal = false;
            item.status = 'incorrect';
            // this.selected[ key ] = "";
            // setTimeout( () => {
            //   this.selected[ key ].status = "rest";
            //   this.selected[ key ].value = false;
            // }, 2000 );
          }
          return temVal;
        },
        true
      );
      // console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          // console.log('item', item);
        });
      }
      return status;
    },
    // processQuestionsList() {
    //   _.each(_.cloneDeep(this.baseQuestionsList), (item, index) => {
    //     if (item.shuffle) {
    //       this.baseQuestionsList[index].answers = _.shuffle(item.answers);
    //     }
    //   });
    //   this.baseQuestionsList = (this.questonShuffle) ? _.shuffle(this.baseQuestionsList) : this.baseQuestionsList;
    //   return this.baseQuestionsList;
    // }
    getElementStyle(element) {
      element.offsetVertical = element.offsetVertical
        ? element.offsetVertical
        : this.startGameConfig.questionOffsetVertical;
      element.offsetHorizontal = element.offsetHorizontal
        ? element.offsetHorizontal
        : this.startGameConfig.questionOffsetHorizontal;
      element.width = element.width ? element.width : this.startGameConfig.questionWidth;
      element.height = element.height ? element.height : this.startGameConfig.questionHeight;
      return {
        position: 'absolute',
        top: utils.elementTopPosition(element.pos.y, element.offsetVertical),
        left: utils.elementLeftPosition(element.pos.x, element.offsetHorizontal),
        width: utils.elementWidth(element.width),
        height: utils.elementHeight(element.height),
      };
    },
  },
  computed: {
    processedQuestionsList() {
      return this.processQuestionsList();
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$backgroundWidth: 1906px;
$backgroundHeight: 900px;
$backgroundOffsetTop: 140px;
$backgroundOffsetLeft: 0;
// .checkbox-container {
//     @media (min-width: 1200px) {
//         max-width: 97%;
//         width: 1780px;
//     }
// }
.game-tr-multi-checkbox-impr {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  top: $backgroundOffsetTop;
  left: $backgroundOffsetLeft;
  height: $backgroundHeight;
  width: $backgroundWidth;

  .block {
    pointer-events: none;
  }
  .element-container {
    position: relative;
    display: block;

    .inner-element-container {
      display: block;

      width: 100%;
      height: 30%;
    }
    .item-container {
      display: flex;
      min-width: 22%;
      justify-content: flex-start;
      align-items: center;
      height: 49px;

      /* The checkbox-container */
      .checkbox-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        height: 49px;
        padding-left: 60px;
        margin-bottom: 12px;
        cursor: pointer;
        // font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        .text-container {
        }
      }
      .block {
        pointer-events: none;
      }
      /* Hide the browser's default radio button */
      .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
  .main-image-container {
    position: relative;
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
<style lang="scss">
$multiCheckboxColor: #f1f1f1;
.checkmark {
  background-color: $multiCheckboxColor;
}
</style>
